/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceEventPageDto } from '../../models/device-event-page-dto';

export interface GetDeviceIotEvents$Params {
  endDate?: string;
  numberOfEvents?: number;
  sourceDeviceId?: number;
  startDate?: string;
}

export function getDeviceIotEvents(http: HttpClient, rootUrl: string, params?: GetDeviceIotEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceEventPageDto>> {
  const rb = new RequestBuilder(rootUrl, getDeviceIotEvents.PATH, 'get');
  if (params) {
    rb.query('endDate', params.endDate, {});
    rb.query('numberOfEvents', params.numberOfEvents, {});
    rb.query('sourceDeviceId', params.sourceDeviceId, {});
    rb.query('startDate', params.startDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeviceEventPageDto>;
    })
  );
}

getDeviceIotEvents.PATH = '/api/telemetry/device/events';
